import { ReactNode, useState } from "react";
import { AnimatePresence } from "framer-motion";
import { CustomerHeader } from "./customer-header";
import { CustomerSidebar } from "./customer-sidebar";
import { CustomerBottomNav } from "./customer-bottom-nav";
import { ImpersonationBanner, useImpersonation } from "@/components/impersonation-banner";
import { cn } from "@/lib/utils";

interface CustomerLayoutProps {
  children: ReactNode;
}

export function CustomerLayout({ children }: CustomerLayoutProps) {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const { isImpersonating } = useImpersonation();

  return (
    <div className="min-h-screen bg-background">
      {/* Impersonation Banner (admin viewing as customer) - fixed at top */}
      <ImpersonationBanner />

      {/* Top Header - offset by banner height when impersonating */}
      <CustomerHeader
        onMenuClick={() => setSidebarCollapsed(!sidebarCollapsed)}
        topOffset={isImpersonating}
      />

      {/* Sidebar - Desktop only */}
      <CustomerSidebar
        isCollapsed={sidebarCollapsed}
        onToggleCollapse={() => setSidebarCollapsed(!sidebarCollapsed)}
        topOffset={isImpersonating}
      />

      {/* Main Content - extra padding when banner is visible */}
      <main
        className={cn(
          "min-h-screen pb-16 md:pb-0 transition-all duration-300",
          "md:ml-[280px]",
          sidebarCollapsed && "md:ml-[80px]",
          isImpersonating ? "pt-[104px]" : "pt-16"
        )}
      >
        <AnimatePresence mode="wait">
          {children}
        </AnimatePresence>
      </main>

      {/* Bottom Navigation (Mobile) */}
      <CustomerBottomNav />
    </div>
  );
}
